<template>
    <Bar v-if="loaded" id="bar" :data="barData" :options="barConfig" :key="key" />
</template>

<script lang="ts">
import BarComponent from './BarComponent';
export default BarComponent;
</script>